export enum ConfigMetrics {
    HideTearsheetMetrics = 'hide_tearsheet_metrics',
    AlertsQuarters = 'alerts_quarters',
    ReviewPermissions = 'review_permissions',
    AdminPdfEdit  = 'admin_pdf_edit',
    CombineTearsheet = 'combine_tearsheet',
    TearsheetPartnerFundsExclude = 'tearsheet_partner_funds_exclude',
    PackageExcludedFunds = 'package_exclusion_funds',
    ValuationWriteupQCSConsolidated = 'Valuation_Write_up_QCS_Consolidated',
    TearsheetAggregateFund = 'tearsheet_aggregate_fund',
    TearsheetSummaryCombine = 'tearsheet_summary_combine'
}